import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-2fa-input', {
    mixins: [FormElementMixin],
    props: {
        type: {
            type: String,
            default: 'text'
        },
        icon: {
            type: String,
        },
        showClear: {
            type: Boolean,
        },
        tabIndex: {
            required: false,
        },
        maxlength: {
            type: Number,
        },
        autocompleteOff: {
            type: Boolean,
        },
        length: {
            type: Number,
            default: 6, // Default to a 6-digit code
        },
    },
    data() {
        return {
            codeArray: new Array(this.length).fill(""),
        };
    },
    watch: {
        currentValue(newVal) {
            if (newVal.length === this.length) {
                this.codeArray = newVal.split("");
                this.$emit('submit');
            }
        },
        codeArray: {
            handler(newCodeArray) {
                this.currentValue = newCodeArray.join("");
            },
            deep: true,
        },
    },
    methods: {
        handleInput(index, event) {
            const value = event.target.value.replace(/\D/g, ""); // Allow only numbers
            if (! value) {
                this.codeArray = new Array(this.length).fill(null);
                return;
            }

            // If it's a paste (multiple digits at once), handle the whole string
            if (value.length > 1) {
                const values = value.slice(0, this.length).split("");
                // In case they paste a value that is not the length of the code array we make an extra array for the leftover code parts
                const leftOverCodeParts = (new Array(this.length - values.length)).fill(null);
                // we concat the leftover code parts here
                this.codeArray = values.concat(leftOverCodeParts);

                this.$nextTick(() => {
                    // Move focus to the last field filled
                    const lastIndex = Math.min(values.length, this.length - 1);
                    document.getElementById(`${this.id}-${lastIndex}`).focus();
                });

                return;
            }

            this.codeArray[index] = value.slice(-1); // Take only the last digit
            // Move focus to the next input
            if (index < this.length - 1) {
                this.$nextTick(() => {
                    document.getElementById(`${this.id}-${index + 1}`).focus();
                });
            }
        },
        handleKeydown(index, event) {
            if (event.key === "Backspace" && !this.codeArray[index] && index > 0) {
                this.$nextTick(() => {
                    document.getElementById(`${this.id}-${index - 1}`).focus();
                });
            }
        },
    },
}, 'form/controls/ak-2fa-input.html');
